import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Box,
  Checkbox,
  Button,
  FormControlLabel,
} from '@material-ui/core';

import RPGOLogoWhite from '../../../../../../../assets/r_puntos_go_logo_white.svg';

import noSubscribedStyle from './styles';

import {
  legalRPGOBank,
  termsRPGOBank,
} from '../../../../../../../config/paths';

const PointsTitleTerm = () => {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [redTermsLink, setRedTermsLink] = useState(false);
  const classes = noSubscribedStyle();

  const onChangeAcceptedTerms = () => {
    if (!acceptedTerms) setRedTermsLink(false);
    setAcceptedTerms(!acceptedTerms);
  };

  const onClickAcceptTerms = () => {
    if (!acceptedTerms) setRedTermsLink(true);
  };

  return (
    <React.Fragment>
      <Typography className={classes.howGetPoints} align="center">
        Para acumular Ripley Puntos Go solo debes inscribirte
      </Typography>
      <Box display="flex" flexDirection="row" marginTop="10px">
        <FormControlLabel
          className={redTermsLink && classes.checkboxError}
          control={
            <Checkbox
              checked={acceptedTerms}
              color="primary"
              onChange={onChangeAcceptedTerms}
            />
          }
          label={
            <span
              data-cy={'textAcceptTerms'}
              className={redTermsLink ? classes.redLink : classes.acceptTerms}
            >
              Acepto los{' '}
              <b>
                <a href={termsRPGOBank} target="_blank" rel="noreferrer">
                  Términos y Condiciones
                </a>
              </b>{' '}
              y las{' '}
              <b>
                <a href={legalRPGOBank} target="_blank" rel="noreferrer">
                  Políticas de Privacidad
                </a>
              </b>
            </span>
          }
        />
      </Box>
      <Box display="flex" flexDirection="row">
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          disableElevation
          endIcon={<img src={RPGOLogoWhite} />}
          onClick={onClickAcceptTerms}
          data-cy={'acceptTermsButton'}
        >
          <span className={classes.acceptTermsText}>Acumular</span>
        </Button>
      </Box>
    </React.Fragment>
  );
};

PointsTitleTerm.propTypes = {
  mobile: PropTypes.bool,
  type: PropTypes.string,
  points: PropTypes.number,
};

export default PointsTitleTerm;
